<template>
  <a-layout-content v-if="basedData.length !== 0">
    <div v-if="pageLoading === false">
      <a-row :gutter="8">
        <a-col :xs="{span:24}">
          <a-card>
            <div slot="title">
              <span class="d-block">Manifest Alokasi</span>
              <small v-if="basedData.header">{{basedData.header.no_alokasi}}</small>
            </div>
            <!-- <a-button
              size="default"
              @click="handlePrint"
              slot="extra"
              icon="printer"
            >{{!isMobile ? 'Print Manifest' : '' }}</a-button> -->

            <ul class="list-wrapper bordered">
              <li>
                <span class="list-title" for>Tanggal Absensi</span>
                <span
                  class="list-desc"
                  v-if="basedData.header">{{moment(basedData.header.create_dt).format(getDefaultDateFormat)}}</span>
              </li>
              <li>
                <span class="list-title" for>Nama Pegawai</span>
                <span class="list-desc" v-if="basedData.header">{{basedData.header.tlc}}</span>
              </li>
              <li>
                <span class="list-title" for>Departemen / Divisi</span>
                <span class="list-desc" v-if="basedData.header">{{basedData.header.departemen}}</span>
              </li>
              <li>
                <span class="list-title" for>Jabatan</span>
                <span class="list-desc" v-if="basedData.header">{{basedData.header.posisi}}</span>
              </li>
              <li>
                <span class="list-title" for>Periode</span>
                <span
                  class="list-desc"
                  v-if="basedData.header"  >{{basedData.header.awal_periode + ' - ' + basedData.header.akhir_periode}}</span>
              </li>
              <li>
                <span class="list-title" for>Site</span>
                <span class="list-desc" v-if="basedData.header">{{basedData.header.site}}</span>
              </li>
            </ul>
          </a-card>
          <a-card class="m-top d-flex flex-column nowrap" title="Detail rekap Alokasi">
            <a-list :grid="{ gutter: 16,lg: 1 }" :dataSource="basedData.detail" :pagination="pagination">
              <a-list-item slot="renderItem" slot-scope="item">
                <a-card hoverable class="d-flex flex-column nowrap">
                  <div slot="title" class="d-flex justify-between">
                    <span class="list-title">Kode Proyek</span>
                    <a-tag>{{item.c_proyek}}</a-tag>
                  </div>
                  <a-list-item-meta>
                    <ul slot="description" class="list-wrapper">
                      <li class="m-remove">
                        <span class="list-title">Nama Proyek</span>
                        <span class="list-desc">{{item.nama_proyek}}</span>
                      </li>
                      <li class="m-remove">
                        <span class="list-title">Persentase</span>
                        <span class="list-desc">{{item.persentase}}</span>
                      </li>
                      <li class="m-remove">
                        <span class="list-title">Deskripsi</span>
                        <span class="list-desc">{{item.deskripsi}}</span>
                      </li>
                    </ul>
                  </a-list-item-meta>
                </a-card>
              </a-list-item>
            </a-list>
          </a-card>
          <a-collapse class="m-top" activeKey="">
            <a-collapse-panel key="1">
              <div class="d-flex justify-between align-middle" slot="header">
                <h4 class="m-remove">Status</h4>
                <div>
                  <Status :status="basedData.last_status" />
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">Pembuat - {{basedData.header.user_create}}</div>
                  <div class="m-timeline-body">
                    <h4 class="m-remove">{{basedData.header.create_dt}}</h4>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">{{basedData.header.status}}</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in basedData.status_app"
                  :key="workflow.step_no"
                  :color="workflow.status === 'On Process' || workflow.status === 'Delivered' ? 'red' : workflow.status === 'Waiting' ? 'grey' : 'green'"
                >
                  <div
                    class="m-timeline-title"
                  >{{workflow.actor === null ? workflow.jenis : workflow.actor}} {{workflow.tlc ? ' - ' + workflow.tlc : ''}}</div>
                  <div class="m-timeline-body">
                    <h4
                      class="m-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >{{workflow.tanggal_aksi}}</h4>
                    <span
                      class="m-text-small"
                      v-if="workflow.remark == null || workflow.remark == ''"
                    >Tidak Ada Catatan</span>
                    <span class="m-text-small" v-else>{{workflow.remark}}</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
          <a-card
            class="m-top"
            :loading="pageLoading"
            v-if="basedData.jenis.toLowerCase() === 'approve'"
          >
            <div slot="title">Tindakan Manifest</div>

            <a-form :form="form">
              <a-form-item label="Catatan">
                <a-textarea
                  placeholder="Tulis catatan disini ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select showSearch v-decorator="['aksi', {rules: [{required: true}]}]">
                  <a-select-option v-for="item in basedData.aksi" :key="item.aksi">{{item.aksi}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Password">
                <a-input
                  type="password"
                  placeholder="Password"
                  v-decorator="['password', {rules: [{required: true}]}]"
                />
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button @click="handleSubmit" block type="primary" html-type="submit">Simpan</a-button>
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import Status from "@/components/Status.vue";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "manifestapproval",
  props: ["id"],
  components: { Status },
  data() {
    return {
      pageLoading: true,
      basedData: {
        jenis: "",
        header: {
          create_dt: undefined,
          user_create: undefined,
          status: "",
        }
      },
      submit: {},
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 5,
        size: "small"
      }
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetchManifest();
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleSubmitProcess);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleSubmitProcess);
  },
  computed: {
    ...mapGetters(["getScreen","getDefaultDateFormat"])
  },
  methods: {
    moment,
    fetchManifest() {
      axios({
        method: "get",
        url: this.$serviceUrl + "public_manifest/manifest_alokasipekerjaan", //public_manifest/manifest_cuti
        params: {
          id: this.id
        }
      })
        .then(response => {
          console.log(response);
          if (response.data) {
            this.basedData = {
              header: response.data.header[0],
              detail: response.data.detail,
              notifikasi: response.data.notifikasi,
              status_app :   response.data.status_app,
              status: response.data.status,
              jenis: response.data.jenis,
              id_manifest: response.data.id_manifest,
              aksi: response.data.aksi

            };
          }
          this.pageLoading = false;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.$notification.error({
              message: "Error",
              description: "Gangguan system, error code 404!"
            });
          }
          this.pageLoading = false;
        });
    },
    handlePrint() {},
    handleAction() {},
    handleSubmit() {
      this.confirmMessage("confirm-save");
    },
    handleSubmitProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.$notification.error({
            message: "Error",
            description: "Pilih Aksi Terlebih Dahulu!"
          });
          return;
        }

        let postData = new FormData();

        postData.append("id_manifest", this.basedData.id_manifest);
        postData.append("status", values.aksi);
        postData.append("remark", values.catatan ? values.catatan : "");
        postData.append("tlc", this.basedData.status_app[0].tlc);
        postData.append("password", values.password);

        axios({
          method: "post",
          url: this.$serviceUrl + "public_manifest/approval_alokasipekerjaan",
          processData: false,
          data: postData
        })
          .then(response => {
            this.$notification.success({
              message: "Sukses",
              description: "Data telah berhasil diproses!"
            });
            this.$router.go();
          })
          .catch(err => {
            // console.log("error : " + err);
            if (err.response.data.status === false) {
              this.$notification.error({
                message: "Error",
                description: "Password Anda Salah!"
              });
            }
            this.pageLoading = false;
          });
      });
    }
  }
};
</script>

<style>
</style> 